<template>
  <v-container
    fluid
    grid-list-xl
    pt-0
  >
    <v-layout wrap>
      <v-flex
        xs12
      >
        <material-card
          :title="'月模組生產概況篩選 (' + summaryMonth + ')'"
          class="card-shrink card-padding v-card__first"
          color="general"
        >
          <div class="card-memo-1 text-white">
            <v-icon class="text-warning">mdi-checkbox-blank</v-icon>
            黃字代表不良率大於1%</div>
          <div class="card-memo-2 text-white">
            <v-icon class="text-danger">mdi-checkbox-blank</v-icon>
            紅字代表不良率大於3%</div>
          <v-form>
            <v-container
              py-0
              class="mw-100">
              <v-layout wrap>
                <v-flex
                  xs12
                  lg3>
                  <v-menu
                    v-model="summaryMonthMenu"
                    :close-on-content-click="false"
                    :nudge-left="40"
                    lazy
                    transition="scale-transition"
                    max-width="290px"
                    offset-y
                    full-width
                  >
                    <v-text-field
                      slot="activator"
                      :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                      v-model="summaryMonth"
                      label="時間"
                      prepend-icon="event"
                    />
                    <v-date-picker
                      v-model="summaryMonth"
                      :min="startdate"
                      :max="new Date() | date-format"
                      :color="theme==='dark'?'danger':'general'"
                      type="month"
                      no-title
                      scrollable
                      actions/>
                  </v-menu>
                </v-flex>
                <v-flex
                  xs12
                  sm6
                  lg3>
                  <v-autocomplete
                    v-model="summaryVendor"
                    :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                    :items="summaryVendorMenu"
                    label="供應商"
                    class="v-text-field__slot"
                    persistent-hint
                    outlined
                  />
                </v-flex>
                <v-flex
                  xs12
                  sm6
                  lg3>
                  <v-autocomplete
                    v-model="summaryAsusDeviceIsn"
                    :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                    :items="summaryAsusDeviceIsnMenu"
                    label="ASUS料號"
                    class="v-text-field__slot"
                    color="white"
                    persistent-hint
                    outlined
                  />
                </v-flex>
                <v-flex
                  xs12
                  lg3
                  text-xs-right
                >
                  <v-btn
                    class="mx-0 font-weight-light"
                    color="general"
                    @click="doSubmit()"
                  >
                    <v-icon class="mr-2">mdi-backup-restore</v-icon>查詢
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </material-card>
        <material-card>
          <div class="calendar">
            <div>
              <div style="margin-left: 70px;">
                <div
                  v-for="(week, w) in WeekList"
                  :key="'w'+w"
                  class="calendar-week">
                  <span>{{ week }}</span>
                </div>
              </div>
              <div
                v-for="(list, d) in summaryMonthWeeksList"
                :key="'d'+d"
                :class="{'calendar-row-unfold': summaryWeeksMatch(list.weeks)}"
                class="calendar-row mr-0 ml-0">
                <div class="calendar-weeks">
                  <span>W {{ list.weeks }}</span>
                  <router-link
                    :to="'/thermalModule/pl2/weeklyThermalModuleProdutionSummary/' + weekParam(list)"
                    target="_blank">
                    <v-btn
                      title="檢示每週生產概要"
                      class="black text-light pl-2 pr-2"><v-icon>mdi-clipboard-text-outline</v-icon></v-btn>
                  </router-link>
                </div>
                <div
                  v-for="(days, dd) in list.date"
                  :key="'dd'+dd"
                  :class="{'calendar-around': days.around}"
                  class="calendar-day calendar-day-fail">
                  <a style="cursor: default;">
                    {{ days.day }}
                  </a>
                  <v-icon
                    v-if="days.over"
                    class="calendar-day-icon"
                    @click="summaryWeeksArray(list.weeks)">mdi-apple-keyboard-control</v-icon>
                  <div
                    v-for="(fail, f) in days.failList"
                    :key="'f'+f"
                    class="calendar-fail-group">
                    <router-link
                      :to="'/thermalModule/pl2/thermalModuleTestDataStatistc?deviceIsn='+fail.deviceIsn+'&modelname='+fail.modelName+'&date='+days.date+'&vendorpk='+fail.vendorPk+'&vendor='+fail.vendor"
                      :style="'color:' + (fail.warningColor !== '' ? fail.warningColor : theme === 'dark' ? 'rgba(245,245,245,1)' : 'rgba(30,30,30,1)') + '!important;'"
                      :hover="'color:' + (fail.warningColor !== '' ? fail.warningColor : theme === 'dark' ? 'rgba(245,245,245,1)' : 'rgba(30,30,30,1)') + '!important;'"
                      target="_blank"
                      small>
                      <div>{{ (fail.failRate*100).toFixed(1) }}% {{ fail.modelName }}</div>
                      <div class="calendar-fail-bottom">{{ fail.deviceIsn }}</div>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </material-card>
      </v-flex>
      <v-flex
        flex_width_auto
        xs12
      >
        <material-card
          :title="'符合 '+summaryMonth+' 的總合數據'"
          color="deep-orange"
        >
          <v-data-table
            :headers="headers"
            :items="responseFailTable"
            :pagination.sync="pagination"
            class="mt-3 elevation-1"
            multi-sort
            hide-actions
          >
            <template
              slot="headerCell"
              slot-scope="{ header }"
            >
              <span
                class="subheading font-weight-light text-general text--darken-3"
                v-text="header.text"
              />
            </template>
            <template
              slot="items"
              slot-scope="{ item }"
            >
              <td>{{ item.deviceIsn }}</td>
              <td class="text-xs-right">{{ item.productionQty }}</td>
              <td class="text-xs-right">{{ item.failQty }}</td>
              <td class="text-xs-right"><v-chip
                :class="item.warningColor"
                small>{{ (item.failRate*100).toFixed(1) }}%</v-chip></td>
              <td>{{ item.vendor }}</td>
              <td>
                <router-link
                  :to="'/thermalModule/pl2/thermalModuleTestDataStatistc?deviceIsn='+item.deviceIsn+'&modelname='+item.modelName+'&date='+DataStatistcStart+'&daterange='+DataStatistcEnd+'&vendorpk='+item.vendorPk+'&vendor='+item.vendor"
                  target="_blank">
                  <v-btn
                    class="mx-0 mr-3 font-weight-light small"
                    color="primary">
                    <v-icon class="mr-2">mdi-chart-bar</v-icon>當月統計
                  </v-btn>
                </router-link>
              </td>
              <td>
                <v-btn
                  class="mx-0 font-weight-light small"
                  color="green"
                  @click="chartLineViewName=item.deviceIsn;chartLineView=true">
                  <v-icon class="mr-2">mdi-chart-line</v-icon>折線分佈
                </v-btn>
              </td>
            </template>
          </v-data-table>
        </material-card>
      </v-flex>
    </v-layout>
    <v-dialog
      v-model="chartLineView"
      :width="'calc(100% - ' + shrink + 'px)'"
      class="chart-view"
      persistent>
      <v-card
        max-width="85%"
        style="margin:0 auto;">
        <v-card-text>
          <v-alert
            v-model="chartLineView"
            class="mt-3 mb-3 border-0"
            color="brown">
            <strong class="h4">{{ chartLineViewName }} 生產不良率折線分佈 {{ summaryMonth }}</strong>
          </v-alert>
          <vue-c3 :handler="handler_line"/>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            color="red"
            small
            @click="chartLineView=false">
            <v-icon class="mr-2">mdi-close</v-icon>關閉
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="loadingView"
      :width="'calc(100% - ' + shrink + 'px)'"
      class="chart-view"
      persistent>
      <p style="letter-spacing: 5px;text-align: center !important;color: #ffffff;background-color: #000000dd;padding: 15px;width: 50%;margin: auto;">
        <img
          :src="Loading"
          style="width: 2rem;margin-bottom: 10px;">
        <br>
        LOADING 載入中
      </p>
    </v-dialog>
    <v-snackbar
      v-model="snackbar"
      :top="true"
      :color="snackbarColor">
      {{ snackbarMsg }}
      <v-btn
        dark
        flat
        @click="snackbar = false">
        Close
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import Vue from 'vue'
import VueC3 from 'vue-c3'
import 'c3/c3.min.css'
import { mapState } from 'vuex'
import Loading from '@/assets/img/loading.gif'

export default {
  name: 'MonthlyThermalModuleProdutionSummaryPL2',
  components: {
    VueC3
  },
  data () {
    return {
      startdate: '2018-04-01',
      snackbar: false,
      snackbarColor: 'red',
      snackbarMsg: '',
      Loading,
      loadingView: false,
      summaryMonthMenu: false,
      summaryMonth: this.$moment(new Date()).format('YYYY-MM'),
      summaryVendorMenu: [],
      summaryAsusDeviceIsnMenu: [],
      summaryVendor: 'All',
      summaryAsusDeviceIsn: 'All',
      summaryWeeksUnfoldList: [],
      summaryMonthWeeksList: [],
      summaryYearWeeksList: [],
      summaryAllYearWeeksList: [],
      summarySearchYearWeeksList: [],
      responseFailList: [],
      responseFailTable: [],
      chartLineView: false,
      chartLineViewNum: 0,
      chartLineViewName: '',
      DataStatistcStart: '',
      DataStatistcEnd: '',
      barXaxisName: [],
      barXaxisValue: [],
      WeekList: ['一', '二', '三', '四', '五', '六', '日'],
      pagination: {
        rowsPerPage: 1,
        sortBy: 'TotalFailRate', // The field that you're sorting by
        descending: true
      },
      headers: [
        {
          sortable: true,
          text: 'ASUS料號',
          value: 'deviceIsn'
        },
        {
          sortable: true,
          text: '生產數量',
          value: 'productionQty',
          align: 'right'
        },
        {
          sortable: true,
          text: '總不良數量',
          value: 'failQty',
          align: 'right'
        },
        {
          sortable: true,
          text: '總不良率',
          value: 'failRate',
          align: 'right'
        },
        {
          sortable: true,
          text: '供應商',
          value: 'vendor'
        },
        {
          sortable: false,
          text: '熱測數據',
          value: ''
        },
        {
          sortable: false,
          text: '不良率分佈',
          value: ''
        }
      ],
      handler_line: new Vue()
    }
  },
  computed: {
    ...mapState('app', ['theme', 'shrink']),
    options_line () {
      return {
        data: {
          x: 'x',
          columns: [
            this.barXaxisName,
            this.barXaxisValue
          ],
          labels: {
            // format: function (v, id, i, j) { return v + '%' }
          },
          type: 'line',
          colors: {
            // ModelName: '#999999'
          }
          // color: function (color, d) {
          //   // d will be 'id' when called for legends
          //   return d.value >= 5.0 ? '#ff0000' : d.value >= 3.0 ? '#ff9800' : color
          // }
        },
        axis: {
          x: {
            type: 'category', // this needed to load string x value
            tick: {
              rotate: -45,
              multiline: false
            },
            label: {
              text: '日期',
              position: 'outer-center'
            }
          },
          y: {
            tick: {
              format: function (value) { return value + '%' }
            },
            label: {
              text: '不良率',
              position: 'outer-middle'
            }
          }
        },
        tooltip: {
          format: {
            title: (d, value) => {
              return `${this.barXaxisName[d + 1]}`
              // return `第 ${d} 期`
            },
            value: (value, ratio, id) => {
              return `${value} %`
              // return `${value} 億`
            }
          }
        },
        grid: {
          x: {
            show: true
          },
          y: {
            show: true
          }
        },
        legend: {
          position: 'bottom',
          padding: 16,
          show: false
        },
        size: {
          width: ((window.innerWidth - this.shrink) * 0.85) - 64,
          height: 500
        }
      }
    }
  },
  watch: {
    summaryMonth (val) {
      this.summaryMonthMenu = false
      this.loadAsusDeviceIsn()
    },
    summaryVendor () {
      this.loadAsusDeviceIsn()
    },
    chartLineView (val) {
      if (val) {
        this.barXaxisName = ['x']
        this.barXaxisValue = ['不良率']
        this.responseFailList.forEach((r) => {
          this.barXaxisName.push(this.$moment(r.productionDate).format('MM-DD'))
          this.barXaxisValue.push('')
          if (r.productionData.length > 0) {
            r.productionData.forEach((rr) => {
              if (rr.deviceIsn === this.chartLineViewName) {
                this.barXaxisValue[this.barXaxisValue.length - 1] = (rr.failRate * 100).toFixed(1)
              }
            })
          }
        })
        if (this.chartLineViewNum === 0) {
          this.handler_line.$emit('init', this.options_line)
          this.chartLineViewNum++
        } else {
          this.handler_line.$emit('dispatch', chart => {
            const options = {
              columns: [
                this.barXaxisName,
                this.barXaxisValue
              ]
            }
            chart.load(options)
          })
        }
      } else {
        // this.handler_line.$emit('destroy')
      }
    }
  },
  mounted () {
    this.$store.dispatch('getAuthorize', '/thermalModule/pl2/monthlyThermalModuleProdutionSummary')
      .then(response => {
        if (response.status === 'success' && response.data.accessible) {
          JSON.parse(localStorage.getItem('moduleDataInitDate')).forEach((n) => {
            if (n.name === 'thermalModule') {
              this.startdate = n.value
            }
          })
          if (this.$route.params.searchDate) {
            this.summaryMonth = this.$route.params.searchDate
          }
          this.$http.get('/api/getSelectOptionData/vendor').then(res => res.data)
            .then(res => {
              if (res.status === 'success') {
                this.summaryVendorMenu = [{ text: 'All', value: 'All' }].concat(res.data)
              }
            })
          this.loadAsusDeviceIsn()
          this.loadData()
        } else if (response.errCode === 'E10000002') {
          const routeData = this.$router.resolve({ path: '/noEnter/E10000002' })
          localStorage.setItem('errormsg', response.errMsg)
          window.location.assign(routeData.href)
        } else {
          const routeData = this.$router.resolve({ path: JSON.parse(localStorage.getItem('user')).home })
          window.location.assign(routeData.href)
        }
      })
      .catch(err => {
        console.log(err)
        const routeData = this.$router.resolve({ path: JSON.parse(localStorage.getItem('user')).home })
        window.location.assign(routeData.href)
      })
  },
  methods: {
    loadAsusDeviceIsn () {
      const queryStartDate = this.$moment(this.summaryMonth + '-01').format('YYYY-MM-DD')
      const queryEndDate = this.$moment(this.summaryMonth + '-01').endOf('month').format('YYYY-MM-DD')
      let url = '/api/getSelectOptionData/thermalModuleAsusDeviceIsn?queryStartDate=' + encodeURIComponent(queryStartDate)
      url += '&queryEndDate=' + encodeURIComponent(queryEndDate)
      if (this.summaryVendor && this.summaryVendor !== 'All') {
        url += '&vendorPk=' + encodeURIComponent(this.summaryVendor)
      }
      this.$http.get(url).then(res => res.data)
        .then(res => {
          if (res.status === 'success') {
            this.summaryAsusDeviceIsnMenu = [{ text: 'All', value: 'All' }].concat(res.data)
          }
        })
    },
    async loadData () {
      this.loadingView = true
      await this.YearWeeksList()
      await this.AllYearWeeksList()
      await this.doSubmit()
    },
    YearWeeksList () {
      const yearStart = Number(this.$moment(this.startdate).format('YYYY'))
      const yearEnd = Number(this.$moment(new Date()).format('YYYY')) + 1
      const Arr = []
      for (let y = 0; y <= (yearEnd - yearStart); y++) {
        Arr[y] = []
      }
      let cursor = this.$moment(this.startdate).startOf('isoWeek')
      const last = this.$moment(new Date()).endOf('isoWeek')
      while (cursor.isSameOrBefore(last, 'day')) {
        const isoYear = cursor.isoWeekYear()
        const isoWeek = cursor.isoWeek()
        const y = isoYear - yearStart
        if (y >= 0 && y < Arr.length) {
          Arr[y][isoWeek] = {
            start: cursor.format('YYYY-MM-DD'),
            end: cursor.clone().endOf('isoWeek').format('YYYY-MM-DD')
          }
        }
        cursor = cursor.clone().add(1, 'week').startOf('isoWeek')
      }
      this.summaryYearWeeksList = Arr
    },
    AllYearWeeksList () {
      const SearchArr = []
      const YearStart = this.$moment(this.startdate).format('YYYY')
      const YearEnd = this.$moment(this.summaryMonth).format('YYYY')

      for (let y = 0; y <= (YearEnd - YearStart); y++) {
        SearchArr[y] = []
        for (let w = 1; w < this.summaryYearWeeksList[y].length; w++) {
          if (this.summaryYearWeeksList[y][w]) {
            SearchArr[y].push({ start: this.summaryYearWeeksList[y][w].start, end: this.summaryYearWeeksList[y][w].end })
          }
        }
      }
      this.summarySearchYearWeeksList = SearchArr
    },
    toDateKey (value) {
      if (value == null || value === '') return ''
      if (Array.isArray(value) && value.length >= 3) {
        const mm = String(value[1]).padStart(2, '0')
        const dd = String(value[2]).padStart(2, '0')
        return value[0] + '-' + mm + '-' + dd
      }
      return String(value).replace(/\//g, '-').substr(0, 10)
    },
    weekParam (list) {
      const monday = list.date && list.date[0] && list.date[0].date
      if (monday && this.$moment) {
        const m = this.$moment(monday)
        const y = String(m.isoWeekYear())
        const w = m.isoWeek()
        return y + (w < 10 ? ('0' + w) : String(w))
      }
      const y = String(this.summaryMonth).substr(0, 4)
      const w = list.weeks < 10 ? ('0' + list.weeks) : String(list.weeks)
      return y + w
    },
    buildCalendar (byDate) {
      const first = this.$moment(this.summaryMonth + '-01')
      const last = first.clone().endOf('month')
      const month = first.month()
      let cursor = first.clone().startOf('isoWeek')
      const weeks = []
      while (weeks.length < 7) {
        const weekNo = cursor.isoWeek()
        const days = []
        for (let i = 0; i < 7; i++) {
          const d = cursor.clone().add(i, 'days')
          const dateStr = d.format('YYYY-MM-DD')
          const around = d.month() !== month
          const failList = byDate[dateStr] || []
          days.push({
            day: d.date(),
            date: dateStr,
            around,
            fail: failList.length > 0,
            over: failList.length > 3,
            failList
          })
        }
        weeks.push({ weeks: weekNo, date: days })
        if (cursor.clone().add(6, 'days').isSameOrAfter(last, 'day')) break
        cursor = cursor.clone().add(1, 'week')
      }
      this.summaryMonthWeeksList = weeks
    },
    doSubmit () {
      this.loadingView = true
      const first = this.$moment(this.summaryMonth + '-01')
      const last = first.clone().endOf('month')
      this.DataStatistcStart = first.format('YYYY-MM-DD')
      this.DataStatistcEnd = last.format('YYYY-MM-DD')
      const body = {
        queryStartDate: first.clone().startOf('isoWeek').format('YYYY-MM-DD'),
        queryEndDate: last.clone().endOf('isoWeek').format('YYYY-MM-DD'),
        vendor: this.summaryVendor === 'All' ? '' : this.summaryVendor,
        deviceIsn: this.summaryAsusDeviceIsn === 'All' ? '' : this.summaryAsusDeviceIsn
      }

      this.$http.post('/api/thermalModule/pl2/thermalModuleFailRateSummaryList', body).then(res => res.data)
        .then(res => {
          if (res.status === 'success') {
            this.pagination.rowsPerPage = res.data.length
            this.responseFailTable = res.data
          }
        })
      this.$http.post('/api/thermalModule/pl2/dailyThermalModuleFailRateInfo', body).then(res => res.data)
        .then(res => {
          this.loadingView = false
          if (res.status === 'success') {
            this.responseFailList = res.data
            const byDate = {}
            res.data.forEach((day, i) => {
              const dateKey = this.toDateKey(day.productionDate) || first.clone().startOf('isoWeek').add(i, 'days').format('YYYY-MM-DD')
              byDate[dateKey] = day.productionData || []
            })
            this.buildCalendar(byDate)
          }
        })
    },
    summaryWeeksArray (weeks) {
      if (this.summaryWeeksUnfoldList.findIndex(function checkUnfold (ww) { return ww === weeks }) === -1) {
        this.summaryWeeksUnfoldList.push(weeks)
      } else {
        this.summaryWeeksUnfoldList.splice(this.summaryWeeksUnfoldList.findIndex(function checkUnfold (ww) { return ww === weeks }), 1)
      }
    },
    summaryWeeksMatch (weeks) {
      return this.summaryWeeksUnfoldList.findIndex(function checkUnfold (ww) { return ww === weeks }) > -1
    }
  }
}
</script>
<style>
</style>
